import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import("../views/Home"),
    },
    {
      path: "*",
      redirect: {name: "pageNotFound"}
    },
    {
      path: "/pageNotFound",
      name: "pageNotFound",
      component: () => import("../views/errors/NotFound"),
      props: true
    },
  ]
});

export default router;
